import styled from 'styled-components'
import { StyledButton } from './StyledButton'
import { Action } from '../styles/mixins'

export const ApproveButton = styled(StyledButton).attrs((props) => ({
  backgroundColor:
    props.backgroundColor || 'var(--background-color-approve-button)',
}))`
  ${Action({
    backgroundColor: 'var(--background-color-approve-button)',

    hoverAction: {
      opacity: '0.5',
      backgroundColor: 'var(--background-color-approve-button)',
    },

    disableAction: {
      opacity: '0.5',
      backgroundColor: 'var(--background-color-approve-button)',
    },
  })}
`
